import BaseTextField from '../Base/BaseTextField';

export default function TextDescriptor(props) {
  return <BaseTextField type="text" {...props} />;
}
